"use client";
import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { FaCheckCircle, FaPlus } from "react-icons/fa";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  OutlinedInput,
  FormControl,
  Typography,
  useTheme,
  CircularProgress,
  TextField,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { MdSave, MdCancel } from "react-icons/md";
// import Select from "react-select";
import LoadingBackdrop from "../components/LoadingBackdrop";

import TextareaAutosize from "@mui/material/TextareaAutosize";
// import {BUSINESS_TYPES_SELECT} from "@/app/constants/businessTypes";
import { getCustomTableDialogueStyles } from "../constants/tableDialougeStyles";
import MRTDatatable from "../components/MRTDatatable";
import PROJECT_SERVICE from "../../api/project";
import { IoIosCloseCircle } from "react-icons/io";
import ImageUpload from "../../components/ImageUpload";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
// import Notifications from "@/app/helpers/notifications";

const columns = [
  {
    accessorKey: "name",
    header: "Name",
  },
  {
    accessorKey: "status",
    header: "Status",
      Cell: ({renderedCellValue, row}) => {
          const statusColors = {
              inprogress: "#FFA500",  // Orange
              planning: "#3498DB",   // Blue
              completed: "#2ECC71", // Green
              cancelled: "#E74C3C"  // Red
          };

          return (
              <div
                  style={{
                      backgroundColor: statusColors[renderedCellValue.toLowerCase()] || "#777",
                      color: "white",
                      padding: "3px 15px",
                      borderRadius: "100px",
                      display: "inline-block",
                      cursor: "pointer"
                  }}
              >
                  {renderedCellValue}
              </div>
          );
      },
  },
  {
    accessorKey: "client",
    header: "Client",
  },
  {
    accessorKey: "isFeatured",
    header: "Featured",
    Cell: ({renderedCellValue, row}) => (
      <div>
        {renderedCellValue ? <FaCheckCircle style={{color: 'green', fontSize: '16px'}}/> :
          <IoIosCloseCircle style={{color: 'red', fontSize: '18px'}}/>}
      </div>
    ),
  },
];

export default function Content() {
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [isMounted, setIsMounted] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    desc: "",
    tags: "",
    status: "",
    image: "",
    images: [],
    isFeatured: false,
    client: "",
    timeline: "",
    services: "",
    completion: "",
    information: "",
  });

  const handleOpen = () => {
    setIsEditMode(false);
    setEditingId(null);
    setFormData({
      name: "",
      desc: "",
      tags: "",
      status: "",
      image: "",
      images: [],
      isFeatured: false,
      client: "",
      timeline: "",
      services: "",
      completion: "",
      information: "",
    });
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setIsEditMode(false);
    setEditingId(null);
  };

  const handleChange = e => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSelectChange = (value, action) => {
    setFormData(prev => ({
      ...prev,
      [action.name]: value,
    }));
  };

  const handleInformationChange = (value) => {
    setFormData(prev => ({
      ...prev,
      information: value,
    }));
  };

  const handleSave = async () => {
    setIsLoading(true);
    try {
      // Process images - first image goes to 'image' field, rest go to 'images' array
      if (formData.images && formData.images.length > 0) {
        formData.image = formData.images[0]; // First image as main image
      } else if (formData.image && !formData.images.length) {
        formData.images = [formData.image]; // Single image in array
      }

      if (isEditMode) {
        let data = {
            ...formData,
        }
        const res = await PROJECT_SERVICE.update(editingId, data)
        if (res.status === 200) {
            // await Notifications.successMsg(res?.message)
            await getTableData()
            handleClose()
        } else {
            // await Notifications.errorMsg(res?.message?.user)
        }
      } else {
        let data = {
          ...formData,
        };
        const res = await PROJECT_SERVICE.create(data);

        console.log(res);
        if (res.status === 200) {
          // await Notifications.successMsg(res?.message)
          await getTableData();
          handleClose();
        } else {
          // await Notifications.errorMsg(res?.message?.user)
        }
      }
    } catch (error) {
      console.error('Save error:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleEdit = tableMeta => {
    // Handle both single image and multiple images
    const images = Array.isArray(tableMeta?.images) ? tableMeta.images : 
                  tableMeta?.image ? [tableMeta.image] : [];
    
    setFormData({
      name: tableMeta?.name,
      desc: tableMeta?.desc,
      tags: tableMeta?.tags,
      status: tableMeta?.status,
      image: tableMeta?.image || "",
      images: images,
      isFeatured: tableMeta?.isFeatured,
      client: tableMeta?.client,
      timeline: tableMeta?.timeline,
      services: tableMeta?.services,
      completion: tableMeta?.completion,
      information: tableMeta?.information || "",
    })

    setIsEditMode(true)
    setEditingId(tableMeta?._id)
    setOpen(true)
  };

  const handleDelete = async tableMeta => {
    setIsDeleting(true)
    try {
        const res = await PROJECT_SERVICE.destroy(tableMeta?._id)
        if (res.status === 200) {
            // await Notifications.successMsg(res?.message)
            await getTableData()
        } else {
            // await Notifications.errorMsg(res?.message?.user)
        }
    } catch (error) {

    } finally {
        setIsDeleting(false)
    }
  };

  async function getTableData() {
    const res = await PROJECT_SERVICE.all();
    if (res.status === 200) {
      setTableData(res?.data);
    }
  }

  useEffect(() => {
    setIsMounted(true);
    getTableData()
  }, []);

  // Auto-calculate discount when price or originalPrice changes
  // useEffect(() => {
  //     const {price, originalPrice} = formData;
  //     if (price && originalPrice && !isNaN(price) && !isNaN(originalPrice) && parseFloat(originalPrice) > 0) {
  //         const priceNum = parseFloat(price);
  //         const originalPriceNum = parseFloat(originalPrice);
  //         const discountPercentage = ((originalPriceNum - priceNum) / originalPriceNum * 100).toFixed(0);
  //
  //         // Only update if the calculated discount is different from current
  //         if (parseFloat(discountPercentage) !== parseFloat(formData.discount)) {
  //             setFormData(prev => ({
  //                 ...prev,
  //                 discount: discountPercentage
  //             }));
  //         }
  //     } else if (!price || !originalPrice) {
  //         // Clear discount if either price field is empty
  //         if (formData.discount !== "") {
  //             setFormData(prev => ({
  //                 ...prev,
  //                 discount: ""
  //             }));
  //         }
  //     }
  // }, [formData.price, formData.originalPrice]);

  return (
    <Box sx={{ width: "100%" }}>
      <LoadingBackdrop
        open={isDeleting}
        message="Deleting Record"
      />

      {isMounted && (
        <>
          <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
            <Button
              variant="contained"
              color="primary"
              startIcon={<FaPlus style={{ fontSize: "10px" }} />}
              onClick={handleOpen}
              size="small"
            >
              Create
            </Button>
          </Box>
          <MRTDatatable
            title="Product Offers"
            columns={columns}
            data={tableData}
            onEdit={handleEdit}
            onDelete={handleDelete}
          />
        </>
      )}

      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>{isEditMode ? "Edit Offer" : "Create Offer"}</DialogTitle>
        <DialogContent>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                md: "1fr 1fr",
              },
              gap: 2,
              mt: 2,
            }}
          >
            <FormControl fullWidth>
              <Typography
                variant="body2"
                sx={{ mb: 1 }}
              >
                Name
              </Typography>
              <OutlinedInput
                name="name"
                value={formData.name}
                onChange={handleChange}
                fullWidth
              />
            </FormControl>

            <FormControl fullWidth>
              <Typography
                variant="body2"
                sx={{ mb: 1 }}
              >
                Status
              </Typography>
              <Select
                name="status"
                value={formData.status}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    status: e.target.value,
                  }))
                }
                displayEmpty
                fullWidth
              >
                <MenuItem value="">
                  <em>Select Status</em>
                </MenuItem>
                <MenuItem value="inprogress">In Progress</MenuItem>
                <MenuItem value="planning">Planning</MenuItem>
                <MenuItem value="completed">Completed</MenuItem>
                <MenuItem value="cancelled">Canceled</MenuItem>
              </Select>
            </FormControl>

            <FormControl fullWidth>
              <Typography
                variant="body2"
                sx={{ mb: 1 }}
              >
                Description
              </Typography>
              <TextareaAutosize
                name="desc"
                value={formData.desc}
                onChange={handleChange}
                aria-label="description"
                placeholder="Enter Description..."
                style={{ padding: 5 }}
                minRows={3}
                // style={{ width: 700 }}
              />
            </FormControl>

            <FormControl fullWidth>
              <Typography
                variant="body2"
                sx={{ mb: 1 }}
              >
                Tags
              </Typography>
              <TextareaAutosize
                name="tags"
                value={formData.tags}
                onChange={handleChange}
                aria-label="description"
                placeholder="Enter Tags..."
                style={{ padding: 5 }}
                minRows={3}
                // style={{ width: 700 }}
              />
            </FormControl>

            <FormControl fullWidth>
              <Typography
                variant="body2"
                sx={{ mb: 1 }}
              >
                Client
              </Typography>
              <OutlinedInput
                name="client"
                value={formData.client}
                onChange={handleChange}
                fullWidth
              />
            </FormControl>

            <FormControl fullWidth>
              <Typography
                variant="body2"
                sx={{ mb: 1 }}
              >
                Services
              </Typography>
              <OutlinedInput
                name="services"
                value={formData.services}
                onChange={handleChange}
                fullWidth
              />
            </FormControl>

            <FormControl fullWidth>
              <Typography
                variant="body2"
                sx={{ mb: 1 }}
              >
                Timeline
              </Typography>
              <OutlinedInput
                name="timeline"
                value={formData.timeline}
                onChange={handleChange}
                fullWidth
              />
            </FormControl>

            <FormControl fullWidth>
              <Typography
                variant="body2"
                sx={{ mb: 1 }}
              >
                Completion
              </Typography>
              <OutlinedInput
                name="completion"
                value={formData.completion}
                onChange={handleChange}
                fullWidth
              />
            </FormControl>

            <FormControl fullWidth>
              <Typography
                variant="body2"
                sx={{ mb: 1 }}
              >
                Images
              </Typography>
              <ImageUpload
                value={formData.images}
                onChange={(images) => setFormData(prev => ({ ...prev, images }))}
                multiple={true}
                maxFiles={10}
              />
            </FormControl>

            <FormControl fullWidth sx={{ gridColumn: { xs: "1", md: "1 / -1" } }}>
              <Typography
                variant="body2"
                sx={{ mb: 1 }}
              >
                Project Information
              </Typography>
              <Box
                sx={{
                  "& .ql-container": {
                    minHeight: "200px",
                  },
                  "& .ql-editor": {
                    minHeight: "200px",
                  },
                }}
              >
                <ReactQuill
                  theme="snow"
                  value={formData.information}
                  onChange={handleInformationChange}
                  modules={{
                    toolbar: [
                      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                      ['bold', 'italic', 'underline', 'strike'],
                      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                      [{ 'script': 'sub'}, { 'script': 'super' }],
                      [{ 'indent': '-1'}, { 'indent': '+1' }],
                      [{ 'color': [] }, { 'background': [] }],
                      [{ 'font': [] }],
                      [{ 'align': [] }],
                      ['link', 'image'],
                      ['clean']
                    ],
                  }}
                  formats={[
                    'header',
                    'bold', 'italic', 'underline', 'strike',
                    'list', 'bullet',
                    'script',
                    'indent',
                    'color', 'background',
                    'font',
                    'align',
                    'link', 'image'
                  ]}
                />
              </Box>
            </FormControl>

            <FormControl>
              <Typography
                variant="body2"
                sx={{ mb: 1 }}
              >
                Flags
              </Typography>
              <Box sx={{ display: "flex", flexDirection: "row", gap: 1 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="isFeatured"
                      checked={formData.isFeatured}
                      onChange={handleChange}
                    />
                  }
                  label="Is Featured"
                />
              </Box>
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            startIcon={<MdCancel />}
            color="error"
            disabled={isLoading}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSave}
            startIcon={isLoading ? <CircularProgress size={16} /> : <MdSave />}
            color="primary"
            disabled={isLoading}
          >
            {isLoading ? "Saving..." : isEditMode ? "Update" : "Save"}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
